import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { toast } from "react-toastify";

export const sliderStyles = {
  position: "relative",
  display: "inline-block",
  width: "60px",
  height: "34px",

  borderRadius: "34px",
  cursor: "pointer",
  transition: "0.4s",
};

const AccommodationDraggableItem = ({
  selectedNewListItem,
  setIsDragging,
  requestToPayload,
  setRequestToPayload,
  handleToggleClick,
}) => {
  const location = useLocation();
  const numberOfNights = location?.state?.number_of_nights;
  const nightArray = Array.from(
    { length: numberOfNights },
    (_, i) => `Night ${i + 1}`
  );
  const [nightArrayObject, setNightArrayObject] = useState(
    Array.from({ length: numberOfNights }, (_, i) => ({
      value: `Night ${i + 1}`,
      toggle: false,
    }))
  );

  const [draggedList, setDraggedList] = useState([]);
  const [selectedList, setSelectedList] = useState(
    requestToPayload?.tour_package_accommodation_options || []
  );
  const [checkStatus, setCheckStatus] = useState({ id: 0, toggle: false });
  const [addSingleItem, setAddSingleItem] = useState(false)
  const [checkOptionToggle, setCheckOptionToggle] = useState({
    option: null,
    night: null,
  });


  useEffect(() => {
    setSelectedList(requestToPayload?.tour_package_accommodation_options);
  }, [requestToPayload?.tour_package_accommodation_options]);

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  // const handleDrop = (e) => {
  //   e.preventDefault();

  //   const itemJSON = e.dataTransfer.getData("application/json");

  //   if (itemJSON) {
  //     const item = JSON.parse(itemJSON);
  //     console.log({ item });
  //     const exists = Object.values(draggedList).some((day) =>
  //       day.some(
  //         (existingItem) =>
  //           existingItem?.tour_package_accommodation_package_id ===
  //           item?.tour_package_accommodation_package_id
  //       )
  //     );
  //     console.log({ exists });
  //     if (!exists) {
  //       const currentDay = `Night ${Object.keys(selectedList)?.length + 1}`;
  //       if (draggedList[currentDay]) {
  //         setDraggedList({
  //           ...draggedList,
  //           [currentDay]: [...draggedList[currentDay], item],
  //         });
  //       } else {
  //         setDraggedList({
  //           ...draggedList,
  //           [currentDay]: [item],
  //         });
  //       }
  //     }

  //     setIsDragging(false);
  //   }
  // };

  const handleDrop = (e, day, allNights) => {
    e.preventDefault();
    const itemJSON = e.dataTransfer.getData("application/json");
    if (itemJSON) {
      const item = JSON.parse(itemJSON);

      const updatedDraggedList = { ...draggedList };

      allNights.forEach((day) => {
        if (!updatedDraggedList[day]) {
          updatedDraggedList[day] = [];
        }
      });

      const exists = updatedDraggedList[day]?.some(
        (existingItem) => existingItem.meal_package_id === item.meal_package_id
      );

      if (!exists) {
        updatedDraggedList[day] = [...updatedDraggedList[day], item];
        setDraggedList(updatedDraggedList);
      }
      if(exists){
        toast.warn("Maximum room is one.")
      }

      setIsDragging(false);
    }
  };


  const iconObject = {
    dropRight: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M6.75 15L12.75 9L6.75 3"
          stroke="#879FA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    dropDown: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M3 6.75L9 12.75L15 6.75"
          stroke="#879FA8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    edit: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M13.3817 0.644005C12.9851 0.248036 12.4476 0.0256348 11.8872 0.0256348C11.3268 0.0256348 10.7893 0.248036 10.3927 0.644005L0.905373 10.1313C0.633687 10.4015 0.418268 10.7228 0.271581 11.0768C0.124893 11.4308 0.0498491 11.8103 0.05079 12.1934V13.391C0.05079 13.5457 0.112248 13.6941 0.221644 13.8035C0.331041 13.9129 0.479414 13.9743 0.634123 13.9743H1.83171C2.21482 13.9754 2.59434 13.9005 2.9483 13.7539C3.30226 13.6073 3.62362 13.392 3.89379 13.1203L13.3817 3.63242C13.7775 3.23587 13.9998 2.69849 13.9998 2.13821C13.9998 1.57794 13.7775 1.04056 13.3817 0.644005ZM3.06896 12.2955C2.73996 12.6223 2.29543 12.8063 1.83171 12.8077H1.21746V12.1934C1.21687 11.9635 1.26188 11.7358 1.3499 11.5234C1.43791 11.3111 1.56717 11.1183 1.73021 10.9562L8.93029 3.75609L10.272 5.09776L3.06896 12.2955ZM12.5563 2.80759L11.0945 4.27001L9.75279 2.93125L11.2152 1.46884C11.3033 1.38093 11.4078 1.31124 11.5229 1.26374C11.6379 1.21624 11.7612 1.19187 11.8856 1.192C12.0101 1.19214 12.1333 1.21678 12.2482 1.26453C12.3631 1.31228 12.4675 1.3822 12.5554 1.4703C12.6433 1.55839 12.713 1.66294 12.7605 1.77797C12.808 1.893 12.8324 2.01625 12.8323 2.1407C12.8321 2.26515 12.8075 2.38836 12.7597 2.50328C12.712 2.61821 12.6421 2.7226 12.554 2.81051L12.5563 2.80759Z"
          fill="#466773"
        />
      </svg>
    ),
    duplicate: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
      >
        <path
          d="M11.1738 1.90867L9.84142 0.532583C9.67779 0.364563 9.48226 0.230907 9.2663 0.139452C9.05033 0.0479981 8.81828 0.000587085 8.58375 0L5.83333 0C5.16121 0.000848473 4.50994 0.233386 3.98927 0.658419C3.46861 1.08345 3.11039 1.67499 2.975 2.33333H2.91667C2.1434 2.33426 1.40208 2.64185 0.855295 3.18863C0.308515 3.73541 0.00092625 4.47674 0 5.25V11.0833C0.00092625 11.8566 0.308515 12.5979 0.855295 13.1447C1.40208 13.6915 2.1434 13.9991 2.91667 14H6.41667C7.18993 13.9991 7.93126 13.6915 8.47804 13.1447C9.02482 12.5979 9.33241 11.8566 9.33333 11.0833V11.025C9.99168 10.8896 10.5832 10.5314 11.0083 10.0107C11.4333 9.49006 11.6658 8.83879 11.6667 8.16667V3.12667C11.6675 2.67191 11.4907 2.23482 11.1738 1.90867ZM6.41667 12.8333H2.91667C2.45254 12.8333 2.00742 12.649 1.67923 12.3208C1.35104 11.9926 1.16667 11.5475 1.16667 11.0833V5.25C1.16667 4.78587 1.35104 4.34075 1.67923 4.01256C2.00742 3.68437 2.45254 3.5 2.91667 3.5V8.16667C2.91759 8.93993 3.22518 9.68126 3.77196 10.228C4.31874 10.7748 5.06007 11.0824 5.83333 11.0833H8.16667C8.16667 11.5475 7.98229 11.9926 7.65411 12.3208C7.32592 12.649 6.8808 12.8333 6.41667 12.8333ZM8.75 9.91667H5.83333C5.36921 9.91667 4.92409 9.73229 4.5959 9.4041C4.26771 9.07591 4.08333 8.6308 4.08333 8.16667V2.91667C4.08333 2.45254 4.26771 2.00742 4.5959 1.67923C4.92409 1.35104 5.36921 1.16667 5.83333 1.16667H8.16667V2.33333C8.16667 2.64275 8.28958 2.9395 8.50838 3.15829C8.72717 3.37708 9.02392 3.5 9.33333 3.5H10.5V8.16667C10.5 8.6308 10.3156 9.07591 9.98744 9.4041C9.65925 9.73229 9.21413 9.91667 8.75 9.91667Z"
          fill="#466773"
        />
      </svg>
    ),
  };
  const onHandleToggleClick = (index) => {
    setCheckStatus({ id: index, toggle: !checkStatus?.toggle });
  };

  const handleRemoveNewItem = (night, id) => {
    setDraggedList((prev) => {
      const updatedDay = prev[night].filter(
        (accommodation) => accommodation.tour_package_accommodation_id !== id
      );

      return { ...prev, [night]: updatedDay };
    });
  };

  const handleAddDuplicateItem = (day, newAccommodation) => {
    setDraggedList((prev) => {
      const updatedDay = prev[day]
        ? [...prev[day], newAccommodation]
        : [newAccommodation];
      return { ...prev, [day]: updatedDay };
    });
  };

  const handleSetAccommodation = () => {
    setRequestToPayload((prev) => {
      const existingOptions = prev.tour_package_accommodation_options?.option || []
      
      return {
        ...prev,
        tour_package_accommodation_options : {
          ...prev.tour_package_accommodation_options,
          option: [...existingOptions, draggedList]
        }
      }
    });
    
    setDraggedList([]);
  };

  const onHandleToggleClickForOption = (index) => {
    setNightArrayObject((prevNightArray) => {
      return prevNightArray.map((night, i) => {
        if (i === index) {
          return { ...night, toggle: !night.toggle };
        } else {
          return { ...night, toggle: false }; // Set all other options to false
        }
      });
    });
  };

  const onHandleToggleChangeOption = (index) => {
    if (checkOptionToggle?.option === index) {
      setCheckOptionToggle({
        option: null,
        day: null,
      });
    } else {
      setCheckOptionToggle({
        option: index,
        day: null,
      });
    }
  };

  const onHandleToggleChangeOptionNight = (nightIndex) => {
    if (checkOptionToggle?.night === nightIndex) {
      setCheckOptionToggle((prev) => ({
        ...prev,
        night: null,
      }));
    } else {
      setCheckOptionToggle((prev) => ({
        ...prev,
        night: nightIndex,
      }));
    }
  };

  const handleRemoveFoodFromRequestedToPayload = (
    optionIndex,
    day,
    accommodationPackageId
  ) => {
    const updatedRequestToPayload = { ...requestToPayload };
    const option = updatedRequestToPayload.tour_package_accommodation_options.option;
    const meals = option[optionIndex][day];
    const updatedMeals = meals.filter(
      (accommodation) => accommodation.tour_package_accommodation_id !== accommodationPackageId
    );
    option[optionIndex][day] = updatedMeals;
    setRequestToPayload(updatedRequestToPayload);
  };

  const handleDragOverOption = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDropOption = (e, optionInd, dayIndex) => {
    e.preventDefault();
    const itemJSON = e.dataTransfer.getData("application/json");
    
    if (itemJSON) {
        const item = JSON.parse(itemJSON);
  
        setRequestToPayload(prevState => {
            const existingOptions = [...prevState.tour_package_accommodation_options.option];
            if (existingOptions[optionInd]) {
                const mealPackageIds = existingOptions[optionInd][dayIndex].map(option => option.tour_package_accommodation_id);
                
                if (!mealPackageIds.includes(item.tour_package_accommodation_id)) {
                   
                    if(existingOptions[optionInd][dayIndex].length === 0){
                      existingOptions[optionInd][dayIndex].push(item);
                    }
                    else{
                      toast.warn("Maximum room is one.")
                    }
                } else {
                    toast.warn("Already exists on the item.")
                }
            }
             else {
              toast.warn("Already exists on the item.")
                const newDay = {
                    [`Night ${optionInd + 1}`]: [item]
                };
                existingOptions.push(newDay);
            }
  
            const newState = {
                ...prevState,
                tour_package_accommodation_options: {
                    ...prevState.tour_package_accommodation_options,
                    option: existingOptions
                }
            };
  
            return newState;
        });
    }
  };

  return (
    <>
      {/* New  */}
      {/* Try tabs */}
      <div>
      <ul className="grid grid-cols-4 gap-[8px] text-[12px]">
        {requestToPayload?.tour_package_accommodation_options?.option && requestToPayload?.tour_package_accommodation_options?.option.map((option, index) => (
          <div key={index}>
            <li
              onClick={() => {
                onHandleToggleChangeOption(index);
              }}
              className=""
            >
             
              <div
                href="#"
                aria-current="page"
                className={`w-full rounded-[8px] py-[6px] px-[8px] text-sm font-medium text-center cursor-pointer 
                ${checkOptionToggle?.option === index? " text-tour-dnd bg-tour-primary" : "bg-tour-border text-bg-white"}
                `}
              >
                {"Option "} {index + 1}{" "}
              </div>
            </li>
          </div>
        ))}
      </ul>
      
      </div>
      <div className="flex flex-col ">
        {Object?.keys(selectedList).length > 0 &&
          requestToPayload?.tour_package_accommodation_options?.option.map(
            (option, index) => (
              <div key={index} className="flex flex-col gap-y-[16px]">
                {/* <p>Option {index + 1}</p> */}
                {/* <div
                  onClick={() => {
                    onHandleToggleChangeOption(index);
                  }}
                  key={index}
                  className="flex justify-between items-center  bg-bg-white border-b-[1px] border-tour-border px-[8px] h-[32px] cursor-pointer "
                >
                  <p className="text-[18px]  text-tour-text flex justify-start items-center gap-x-[10px]">
                    {"Option "} {index + 1}{" "}
                    
                  </p>
                  <span className="">
                    {checkOptionToggle?.option === index
                      ? iconObject?.dropDown
                      : iconObject?.dropRight}
                  </span>
                </div> */}
                {checkOptionToggle?.option === index &&
                  Object.keys(option).map((night, nightIndex) => (
                    <div key={nightIndex}>
                      <div
                        onClick={() => {
                          onHandleToggleChangeOptionNight(nightIndex);
                        }}
                        className="flex justify-between items-center  bg-bg-white border-b-[1px] border-tour-border px-[8px] h-[32px] cursor-pointer "
                      >
                        <p className="text-[16px]  text-tour-text flex justify-start items-center gap-x-[10px]">
                          {night}{" "}
                          <span className="text-tour-border text-[14px]">{`(${option[night].length} rooms)`}</span>
                        </p>
                        <span className="">
                          {checkOptionToggle?.night === nightIndex
                            ? iconObject?.dropDown
                            : iconObject?.dropRight}
                        </span>
                      </div>
                      {checkOptionToggle?.night === nightIndex &&
                        option[night].map((accommodation, accommodationIndex) => (
                          // <p key={accommodationIndex}> {meal?.meal_type_name}</p>
                          <div key={accommodationIndex} className="mt-[16px]">
                            <div className="border-[1px] border-tour-secondaryHint rounded-[12px]">
                            <p className="px-[12px] py-[6px] text-tour-text border-b-[1px] bg-[#E6E9EB] rounded-t-[12px] border-tour-secondaryHint font-normal">
                          {" "}
                          {accommodation?.tour_package_accommodation_name}
                        </p>
                              <div className="flex flex-col  px-[12px] pt-[12px] pb-[16px]">
                                <div className="flex flex-col gap-[4px]">
                                <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {selectedNewListItem?.name} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.bed_configuration}{" "}
                                {accommodation?.bed_count} bed
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Type Name"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.tour_package_room_type_name}{" "}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Category"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.tour_package_room_category_name}{" "}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Suitable For"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.suitable_for_persons}
                                {" persons"}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Shareable"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.is_room_shareable
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </p>
                            <p className="text-tour-text  ">
                              <span className="text-[14px] font-normal">
                                Price:{" "}
                              </span>
                              <span className="text-[16px] font-medium">
                                {accommodation?.per_night_room_price} BDT
                              </span>
                            </p>
                                </div>

                                <div className="flex justify-end items-center gap-[16px]">
                                  <div
                                    onClick={() =>
                                      handleRemoveFoodFromRequestedToPayload(
                                        index,
                                        night,
                                        accommodation?.tour_package_accommodation_id
                                      )
                                    }
                                    className="flex flex-row justify-center items-center gap-[4px] text-tour-secondary cursor-pointer border-b-[1px] border-bg-white hover:border-tour-secondary"
                                  >
                                    <p>{iconObject?.edit}</p>
                                    <p>Remove</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      {checkOptionToggle?.night === nightIndex && (
                        <div
                          className="h-[156px]  flex justify-center items-center bg-tour-dnd border-[1px] border-tour-secondaryHint rounded-[8px] mt-[16px]"
                          onDragOver={handleDragOverOption}
                          onDrop={(event) =>
                            handleDropOption(event, index, night)
                          }
                        >
                          <p className="text-[14px] text-tour-text">
                            Drag the food option to this box
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            )
          )}
      </div>

      <div>
        {selectedNewListItem?.name === "Accommodation" && (
          <div className="flex flex-col ">
             <p className="text-tour-text bg-tour-secondaryHint px-[16px] py-[8px] border-l-[2px] border-tour-primary mt-[20px]">
            Add New Option
          </p>
            
          {nightArrayObject &&
            nightArrayObject.map((item, i) => (
              <div key={item?.value} className="my-[12px]">
                {/* <p className="mb-[8px]">{item}</p> */}
                <div
                  onClick={() => {
                    onHandleToggleClickForOption(i);
                  }}
                  // key={index}
                  className="flex justify-between items-center  bg-bg-white border-b-[1px] border-tour-border px-[8px] h-[32px] cursor-pointer "
                >
                  <p className="text-[18px]  text-tour-text flex justify-start items-center gap-x-[10px]">
                    {/* {"Option "} {index + 1}{" "} */}
                    {item?.value}
                    <span className="text-tour-border text-[14px]">{`(${
                      draggedList[item.value]?.length === undefined
                        ? "0"
                        : draggedList[item.value]?.length
                    } rooms)`}</span>
                  </p>
                  <span className="">
                    {item?.toggle === true
                      ? iconObject?.dropDown
                      : iconObject?.dropRight}
                  </span>
                </div>
                {item?.toggle === true && (
                  <div className="flex flex-col ">
                    {Object?.keys(draggedList)?.map((night, index) => (
                      <div
                        key={index}
                        className="w-full max-h-[360px] flex flex-col  overflow-auto "
                      >
                        {item?.value === night &&
                          draggedList[night]?.map((accommodation, i) => (
                            <div key={i} className="mt-[16px]">
                              <div className="border-[1px] border-tour-secondaryHint rounded-[12px]">
                                <p className="px-[12px] py-[6px] text-tour-text border-b-[1px]  rounded-t-[12px] border-tour-secondaryHint font-normal">
                                  {" "}
                                  {accommodation?.tour_package_accommodation_name}
                                </p>
                                <div className="flex flex-col  px-[12px] pt-[12px] pb-[16px]">
                                  <div className="flex flex-col gap-[4px]">
                                    <p className="text-[14px] font-normal">
                                      <span className="text-tour-text">
                                        {"Accommodation : "}
                                      </span>
                                      <span className="text-tour-secondary">
                                {accommodation?.bed_configuration}{" "}
                                {accommodation?.bed_count} bed
                              </span>
                                    </p>
                                    <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Type Name"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.tour_package_room_type_name}{" "}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Category"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.tour_package_room_category_name}{" "}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Suitable For"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.suitable_for_persons}
                                {" persons"}
                              </span>
                            </p>
                            <p className="text-[14px] font-normal">
                              <span className="text-tour-text">
                                {"Shareable"} :{" "}
                              </span>
                              <span className="text-tour-secondary">
                                {accommodation?.is_room_shareable
                                  ? "Yes"
                                  : "No"}
                              </span>
                            </p>
                            <p className="text-tour-text  ">
                              <span className="text-[14px] font-normal">
                                Price:{" "}
                              </span>
                              <span className="text-[16px] font-medium">
                                {accommodation?.per_night_room_price} BDT
                              </span>
                            </p>
                                  </div>

                                  <div className="flex justify-end items-center gap-[16px]">
                                    <div
                                      onClick={() =>
                                        handleRemoveNewItem(
                                          night,
                                          accommodation?.tour_package_accommodation_id
                                        )
                                      }
                                      className="flex flex-row justify-center items-center gap-[4px] text-tour-secondary cursor-pointer border-b-[1px] border-bg-white hover:border-tour-secondary"
                                    >
                                      <p>{iconObject?.edit}</p>
                                      <p>Remove</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))}

                    <div
                      className="h-[156px]  flex justify-center items-center bg-tour-dnd border-[1px] border-tour-secondaryHint rounded-[8px] mt-[16px]"
                      onDragOver={handleDragOver}
                      onDrop={(event) =>
                        handleDrop(event, item.value, nightArray)
                      }
                    >
                      <p className="text-[14px] text-tour-text">
                        Drag the food option to this box
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* <div
                className="h-[156px]  flex justify-center items-center bg-tour-dnd border-[1px] border-tour-secondaryHint rounded-[8px]"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <p className="text-[14px] text-tour-text">
                  Drag the accommodation option to this box
                </p>
              </div> */}

            <div className="mt-[8px]">
              {
                addSingleItem ? "" : (
                  <button
                disabled={draggedList?.length === 0}
                onClick={() => handleSetAccommodation()}
                className="w-full flex justify-center items-center h-[36px] px-[16px] py-[10px] bg-tour-primary text-bg-white text-[14px] border-[1px] border-tour-primary rounded-[50px] hover:bg-tour-secondaryShade transition ease-in duration-300 disabled:bg-bg-semiblack disabled:border-bg-semiblack"
              >
                Add Option
              </button>
                )
              }
            </div>
            {/* Added Toggle */}
            <div className="flex items-center justify-center gap-[12px] mt-[12px]">
              <p className="text-[14px] text-tour-text">
                Is Item Is Inclusive by Default:
              </p>
              <label
                style={sliderStyles}
                className={`${
                  requestToPayload?.tour_package_accommodation_is_inclusive
                    ? "bg-tour-secondary"
                    : "bg-tour-border"
                } `}
              >
                <input
                  type="checkbox"
                  checked={
                    requestToPayload?.tour_package_accommodation_is_inclusive
                  }
                  onChange={() =>
                    setRequestToPayload((prev) => ({
                      ...prev,
                      tour_package_accommodation_is_inclusive:
                        !requestToPayload?.tour_package_accommodation_is_inclusive,
                    }))
                  }
                  style={{ display: "none" }}
                />
                <span
                  style={{
                    transform: `translateX(${
                      requestToPayload?.tour_package_accommodation_is_inclusive
                        ? "26px"
                        : "0"
                    })`,
                    transition: "transform 0.3s ease",
                    content: '""',
                    position: "absolute",
                    height: "26px",
                    width: "26px",
                    left: "4px",
                    bottom: "4px",
                    backgroundColor: "white",
                    borderRadius: "50%",
                  }}
                ></span>
              </label>
            </div>
            <div className="mt-[32px]">
              <button
                onClick={() => handleToggleClick(3)}
                className="w-full flex justify-center items-center h-[36px] px-[16px] py-[10px] text-tour-secondaryShade text-[14px] border-[1px] border-tour-secondaryShade rounded-[50px]
                    hover:bg-tour-secondaryHint transition ease-in duration-300"
              >
                Proceed with Transfer
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AccommodationDraggableItem;
